export default {
  headerTitle: {
    id: 'buyback_bank_header_title',
    defaultMessage: '1/3 Informations Bancaires',
  },
  formTitle: {
    id: 'buyback_bank_form_title',
    defaultMessage: 'Nous en avons besoin pour vous payer',
  },
  formDescription: {
    id: 'buyback_bank_form_description',
    defaultMessage:
      'Comme ça on pourra verser {price, number, currency} directement sur votre compte en banque. Bim, bam, boum !',
  },
  formIbanError: {
    id: 'buyback_bank_form_iban_error',
    defaultMessage: 'Error in Iban',
  },
  formBicError: {
    id: 'buyback_bank_form_bic_error',
    defaultMessage: 'Error in Bic',
  },
  formAccountNumberError: {
    id: 'buyback_bank_form_account_number_error',
    defaultMessage: 'Error in Account Number',
  },
  formRoutingNumberError: {
    id: 'buyback_bank_form_routing_number_error',
    defaultMessage: 'Error in Routing Number',
  },
  formSortCodeError: {
    id: 'buyback_bank_form_sort_code_error',
    defaultMessage: 'Error in Sort Code',
  },
  formApiError: {
    id: 'buyback_bank_form_api_error',
    defaultMessage: 'Internal error, please try again.',
  },
}
